import { render, staticRenderFns } from "./CandidateActions.vue?vue&type=template&id=77556b98&scoped=true"
import script from "./CandidateActions.vue?vue&type=script&lang=js"
export * from "./CandidateActions.vue?vue&type=script&lang=js"
import style0 from "./CandidateActions.vue?vue&type=style&index=0&id=77556b98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77556b98",
  null
  
)

export default component.exports